import { Component, ViewChild, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { compare } from 'fast-json-patch';


@Component({
  selector: 'app-wizardpage-step7-availability',
  templateUrl: './wizardpage-step7.component.html',
  styleUrls: ['./wizardpage-step7.component.scss']
})
export class WizardpageStep7AvailabilityComponent implements OnInit {


  // tslint:disable-next-line:max-line-length
  @Output() continueevnt: EventEmitter<any> = new EventEmitter<any>(); // send event out to parent through emitter, then pass in event through function
  @Output() pagecountevnt: EventEmitter<number> = new EventEmitter<number>();

  isSubmitted = false;
  initForm: any;
  isfetching: boolean;

testnow: any[];
  constructor() { }

  @Input() regForm: UntypedFormGroup;

  planguage = [
    {
      name: 'English', value: 1},
      { name: 'Spanish', value: 2},
      { name: 'Chinese', value: 3},
      { name: 'Russian', value: 4},
      { name: 'Korean', value: 6},
      { name: 'Other', value: 5}
  ];

  ngOnInit(): void {

    this.initForm = this.regForm.value;
    this.isfetching = false;

    this.availClick(this.regForm.get('Availother').value);

  }



  decreasePage() {
    this.pagecountevnt.emit(0);
  }



  availClick(x) {


    const checked = x === null || x === '' ? false : x === 'Other' ? true : x.currentTarget.checked;

    if (checked === true) {
       this.regForm.get('Avail').enable();
     } else {
       this.regForm.get('Avail').disable();
       this.regForm.get('Avail').setValue('');
     }

  }





  step7Submitted(postValue: UntypedFormGroup) {



    postValue.get('Availfull').setValue(postValue.get('Availfull').value === true ||
    postValue.get('Availfull').value === 'Full Time' ? 'Full Time' : '');

    postValue.get('Availpart').setValue(postValue.get('Availpart').value === true ||
     postValue.get('Availpart').value === 'Part Time' ? 'Part Time' : '');

    postValue.get('Availwkend').setValue(postValue.get('Availwkend').value === true ||
     postValue.get('Availwkend').value === 'Weekends' ? 'Weekends' : '');

    postValue.get('Availdays').setValue(postValue.get('Availdays').value === true ||
     postValue.get('Availdays').value === 'Days' ? 'Days' : '');

    postValue.get('Availeve').setValue(postValue.get('Availeve').value === true ||
     postValue.get('Availeve').value === 'Nights' ? 'Nights' : '');

    postValue.get('Availvisits').setValue(postValue.get('Availvisits').value === true ||
     postValue.get('Availvisits').value === 'Live-In' ? 'Live-In' : '');

    postValue.get('Availdiem').setValue(postValue.get('Availdiem').value === true  ||
     postValue.get('Availdiem').value === 'Per Diem' ? 'Per Diem' : '');

    postValue.get('Availother').setValue(postValue.get('Availother').value === true ||
     postValue.get('Availother').value === 'Other' ? 'Other' : '');


    const documentA = this.initForm;
    const documentB = postValue.value;





    const jsonpatchobject = compare(documentA, documentB);





    this.regForm.get('Driver').markAsTouched();
    this.regForm.get('Driver').updateValueAndValidity();
    this.regForm.get('Driver2').markAsTouched();
    this.regForm.get('Driver2').updateValueAndValidity();
    this.regForm.get('Driver3').markAsTouched();
    this.regForm.get('Driver3').updateValueAndValidity();
    this.regForm.get('Avail').markAsTouched();
    this.regForm.get('Avail').updateValueAndValidity();
    this.regForm.get('Language').markAsTouched();
    this.regForm.get('Language').updateValueAndValidity();



    this.isSubmitted = true;
    if (!this.regForm.valid) {
      return false;
    } else {
      // the is the event property of the template emitting the validation value to the parent component
      this.isfetching = true;
      this.continueevnt.emit(jsonpatchobject);
      this.pagecountevnt.emit(1);

      return true;
    }

   }

   isFetching(e) {
    this.isfetching = e; }

}
